import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/media/videos/creator-video-hero-poster.jpg")